<div class="text-sm font-medium text-center mt-8 bg-white text-gray-500  border-primary-500 dark:text-gray-400 dark:border-gray-700 mb-8">
    <ul class="flex flex-wrap -mb-px">

        <ng-container *ngFor="let tab of tabs">
            <li class="me-2">
                <ng-container *ngIf="tab.path == activePath">
                    <a (click)="redirectPage(tab.path)" class="pointer inline-block p-4 text-primary-600 border-b-2 border-primary-700 rounded-t-lg dark:text-primary-500 dark:border-primary-500">
                        {{ tab?.label }}
                    </a>
                </ng-container>
                <ng-container *ngIf="tab.path != activePath">
                    <a (click)="redirectPage(tab.path)" class="pointer inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-primary-700 hover:border-primary-700 dark:hover:text-gray-300">
                        {{ tab?.label }}
                    </a>
                </ng-container>
            </li>
        </ng-container>
        
    </ul>
</div>

<div id="tooltip-invite" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
    Invite User
    <div class="tooltip-arrow" data-popper-arrow></div>
</div>

